import { render, staticRenderFns } from "./FilterAccordion.vue?vue&type=template&id=3a4c51cc&scoped=true"
import script from "./FilterAccordion.vue?vue&type=script&lang=js"
export * from "./FilterAccordion.vue?vue&type=script&lang=js"
import style0 from "./FilterAccordion.vue?vue&type=style&index=0&id=3a4c51cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c51cc",
  null
  
)

export default component.exports